import React, { ReactElement } from 'react';

export default function Reinvest(props: {
    className?: string;
}): ReactElement {
    const { className } = props;

    return (
        <svg className={className} fill='none' height='64' viewBox='0 0 64 64' width='64' xmlns='http://www.w3.org/2000/svg'>
            <path d='M60 33L58 31L56 33H60Z' stroke='currentColor' strokeLinecap='round' />
            <path d='M57.9998 28.2816C56.1284 15.6733 45.2644 6 32.1423 6C18.1766 6 6.76867 16.957 6.03711 30.7478' stroke='currentColor' strokeLinecap='round' />
            <path d='M6.00006 35.7184C7.87146 48.3267 18.7355 58 31.8576 58C45.7765 58 57.1548 47.1163 57.9551 33.3907' stroke='currentColor' strokeLinecap='round' />
            <path d='M8 31L6 33L4 31H8Z' stroke='currentColor' strokeLinecap='round' />
            <path d='M42 28V43.5H22V28' stroke='currentColor' />
            <path d='M28.5 34.5H35.5V43.5H28.5V34.5Z' fill='white' stroke='currentColor' />
            <path d='M38 25.4V23H41V27' stroke='currentColor' />
            <path d='M19 30L31.4308 21.3941C31.7732 21.157 32.2268 21.157 32.5692 21.3941L45 30' stroke='currentColor' strokeLinecap='round' />
            <rect fill='currentColor' height='2.36364' rx='0.590909' width='1.18182' x='33' y='38' />
        </svg>
    );
}